module.exports = "<vb-content-page-view\r\n  [actions]=\"actions\">\r\n\r\n  <div page-title>Inventuren</div>\r\n\r\n  <div page-content>\r\n\r\n    <vb-stocktakings-list\r\n      [stocktakingsList]=\"stocktakings\">\r\n    </vb-stocktakings-list>\r\n\r\n  </div>\r\n\r\n</vb-content-page-view>"


//////////////////
// WEBPACK FOOTER
// ./src/app/store-management/stocktaking/views/stocktakings-list-view/stocktakings-list-view.component.html
// module id = ./src/app/store-management/stocktaking/views/stocktakings-list-view/stocktakings-list-view.component.html
// module chunks = main